import {
  AudioItemValue, DataSource, MediaItemValue, PhotoItemValue, SketchItemValue, VideoItemValue,
} from '@fulcrumapp/fulcrum-core';
import Track from '../track';
import { MetadataLoader, MetadataLoaderCallback } from './media-displayer';

type DataSourceCallback = (id: string, callback: (err: Error, object: any) => void) => void;

export default function metadataLoaderForItem(
  item: MediaItemValue,
  dataSource: DataSource,
): MetadataLoader {
  return (callback: MetadataLoaderCallback) => {
    let loadMetadata: DataSourceCallback | null = null;
    let loadTrackInfo: DataSourceCallback | null = null;
    if (item instanceof PhotoItemValue) {
      loadMetadata = dataSource.getPhoto.bind(dataSource);
    } else if (item instanceof SketchItemValue) {
      loadMetadata = dataSource.getSketch.bind(dataSource);
    } else if (item instanceof VideoItemValue) {
      loadMetadata = dataSource.getVideo.bind(dataSource);
      loadTrackInfo = dataSource.getVideoTrack.bind(dataSource);
    } else if (item instanceof AudioItemValue) {
      loadMetadata = dataSource.getAudio.bind(dataSource);
      loadTrackInfo = dataSource.getAudioTrack.bind(dataSource);
    }
    if (loadMetadata) {
      loadMetadata(item.mediaID, (err, object) => {
        if (err) {
          callback(err, null, null);
          return;
        }

        // the `track` attribute is null when the media has no track
        if (loadTrackInfo && object.track != null) {
          loadTrackInfo(item.mediaID, (dsErr, track) => {
            if (dsErr) {
              callback(dsErr, null, null);
              return;
            }
            callback(null, object, new Track(track));
          });
        } else {
          callback(null, object, null);
        }
      });
    }
  };
}
